import apiFetch from '../apiFetch'

export default function (token, maritalStatus) {
  return apiFetch({ endPoint: `MaritalStatus/${maritalStatus.maritalStatusId}`, method: 'PUT', body: maritalStatus, token: token })
}
